import { RequestService } from '../../services/RequestService';
import { GET_ROLES } from '../constants';

export const getRoles = payload => {
  return RequestService.get(GET_ROLES);
};
